import { render, staticRenderFns } from "./I2FormInputFile.vue?vue&type=template&id=04559b4a&scoped=true"
import script from "./I2FormInputFile.vue?vue&type=script&lang=js"
export * from "./I2FormInputFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04559b4a",
  null
  
)

export default component.exports